<template>
    <div>
        <!-- Header -->
        <li class="dropdown-menu-header">
            <div class="dropdown-header d-flex">
                <h4 class="notification-title mb-0 mr-auto">Notificaciones</h4>
                <b-badge pill variant="light-primary"> {{ rows }} </b-badge>
            </div>
        </li>
        <!-- Notifications -->
        <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="scrollable-container media-list scroll-area"
            tagname="li"
        >
            <!-- System Notification Toggler
            <div class="media d-flex align-items-center">
                <h6 class="font-weight-bolder mr-auto mb-0">
                    System Notifications
                </h6>
                <b-form-checkbox :checked="true" switch />
            </div> -->

            <!-- System Notifications -->
            <b-link v-for="(item, index) in data" :key="index">
                <b-media>
                    <template #aside>
                        <b-avatar
                            size="32"
                            :variant="
                                item.idpeticionestado == 'PE'
                                    ? 'light-success'
                                    : 'light-secondary'
                            "
                        >
                            <feather-icon
                                :icon="
                                    item.idpeticionestado == 'PE'
                                        ? 'ArrowDownRightIcon'
                                        : 'ArrowUpRightIcon'
                                "
                            />
                        </b-avatar>
                    </template>
                    <p class="media-heading">
                        <b-link @click="showModal(item)">
                            {{ item.nombre }}
                        </b-link>
                    </p>
                    <small class="notification-text"
                        >{{ item.cmd }} - {{ item.serial }}</small
                    >
                    <div mt="1" v-if="!item.op_queue" hidden>
                        <b-button
                            size="sm"
                            variant="outline-warning"
                            @click="sendCmd(item.idpeticion)"
                            v-if="!working"
                        >
                            Envio Cmd
                        </b-button>
                        <b-button size="sm" variant="outline-dark" v-else>
                            <b-spinner small />
                            Procesando...
                        </b-button>
                    </div>
                </b-media>
            </b-link>
        </vue-perfect-scrollbar>

        <!-- Cart Footer
        <li class="dropdown-menu-footer">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                block
                >Ver todas las notificaciones</b-button
            >
        </li>-->

        <!-- Info modal -->
        <b-modal
            :id="infoModal.id"
            :title="infoModal.title"
            @hide="resetInfoModal"
            ok-only
            ok-variant="outline-secondary"
            ok-title="Cerrar"
            centered
            size="lg"
            ignore-enforce-focus-selector=".swal2-container, .swal2-center"
        >
            <code>
                {{ infoModal.content.respuesta }}
            </code>

            <pre>
            {{ infoModal.content.response }}
            </pre>
        </b-modal>
    </div>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
    BAvatar,
    BBadge,
    BButton,
    BFormCheckbox,
    BLink,
    BMedia,
    BNavItemDropdown,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";

export default {
    components: {
        BNavItemDropdown,
        BBadge,
        BMedia,
        BLink,
        BAvatar,
        BButton,
        BFormCheckbox,
        VuePerfectScrollbar,
        ToastificationContent,
    },
    directives: {
        Ripple,
    },
    setup() {
        const perfectScrollbarSettings = {
            maxScrollbarLength: 60,
            wheelPropagation: false,
        };

        return {
            perfectScrollbarSettings,
        };
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem("userData")),
            data: {},
            rows: 0,
            infoModal: {
                id: "notification-modal",
                title: "",
                content: {},
            },
            working: false,
        };
    },
    created() {
    },
    methods: {
        search() {
            this.$http
                .get("/peticion/", {
                    params: {
                        idusuario: this.userData.id,
                        estado: "PE, EP",
                    },
                })
                .then((response) => {
                    this.data = response.data.data;
                    this.totalRows();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        totalRows() {
            this.rows = this.data.length;
            this.$emit("rows", this.rows);
        },
        showModal(item, button) {
            this.infoModal.title = `Peticion: ${item.nombre} - ${item.cmd} - ${item.serial}`;
            this.infoModal.content = item;
            this.$root.$emit("bv::show::modal", this.infoModal.id, button);
        },
        resetInfoModal() {
            this.infoModal.title = "";
            this.infoModal.content = "";
        },
        sendCmd(idpeticion) {
            this.workingCmd = true;
            this.$http
                .get("peticion-envio/" + idpeticion)
                .then((response) => {
                    this.workingCmd = false;
                    this.showToast(
                        "Procesado Correctamente",
                        "success",
                        "check"
                    );
                })
                .catch((error) => {
                    this.workingCmd = false;
                    console.log(error);
                    this.$swal({
                        title: "Error",
                        text: error.response.data.message,
                        icon: "error",
                        customClass: {
                            confirmButton: "btn btn-danger",
                        },
                        buttonsStyling: false,
                    });
                });
        },
        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant: variant,
                    icon: icon,
                },
            });
        },
    },
    computed: {},
};
</script>

<style></style>
